import url from 'url';
import DMPLogger from 'utils/logger';
import { commonPVMap } from 'utils/pvurlmap';
import { getUrlParamByKey } from 'utils/urlParams';
import { radar } from '@kmi/react';

let dmpLogger;
const { query } = url.parse(window.location.href, true);

export enum SanfangOperatorType {
    ADD = 1,
    PORTRAIT = 2,
}

export const initDMPLog = () => {
    dmpLogger = new DMPLogger(commonPVMap);
};

export const withLog = (fn1, fn2) => {
    return (...args) => {
        fn1.apply(null, args);
        fn2.apply(null, args);
    };
};

export interface AccountInfo {
    accountId: string;
    accountName: string;
}

export const addFMP = () => {
    radar.fmp();
};

export const addRadarEvent = (params: {
    name: string; // 必填 '事件名'
    event_type?: string; // 【可选】'事件类型'
    category?: string; // 【可选】'业务分类'
    src?: string; // 【可选】'事件相关源文件'
    result_type?: string; // 【可选】'事件结果'
    message?: string; // 【可选】'消息'
    extra_info?: string; // 【可选】'额外信息（建议使用json string）'
}) => {
    radar.event(params);
};

export const getAccount = () => {
    const searchParser = new URLSearchParams(window.location.search);
    // url 附带的accountId
    const queryId = searchParser.get('__accountId__');
    // localStorage 附带的accountId
    const storageInfo: AccountInfo | undefined = JSON.parse(localStorage.getItem('__accountId__'));

    if (queryId === storageInfo?.accountId) {
        return storageInfo;
    } else if (queryId || storageInfo) {
        const accountInfo = {
            accountId: queryId || storageInfo.accountId,
            accountName: storageInfo?.accountName,
        };
        return accountInfo;
    } else {
        return undefined;
    }
};

const accountInfo = getAccount();

// 切换广告账号按钮点击
export const switchLoginClickLog = () => {
    dmpLogger.userClick('DMP_SWITCH_LOGIN_CLICK', {
        account_id: accountInfo?.accountId,
    });
};

// 切换账号跳转
export const switchAccountEnterLog = () => {
    dmpLogger.userClick('DMP_SWITCH_LOGIN', {
        after_account_id: accountInfo?.accountId || 0,
        type: query?.type,
    });
};

// 退出登录点击
export const logoutClickLog = () => {
    dmpLogger.userClick('DMP_LOGOUT', {
        account_id: accountInfo?.accountId,
    });
};

// 标签专区标签点击
export const labelClickLog = (tagItem) => {
    dmpLogger.userClick('DMP_LABEL_CLICK', {
        account_id: accountInfo?.accountId,
        tag_name: tagItem?.tagName,
    });
};

// 标签专区搜索
export const labelSearchLog = (keyword) => {
    if (!keyword) {
        return;
    }

    dmpLogger.userClick('DMP_LABEL_SEARCH', {
        account_id: accountInfo?.accountId,
        search_keyword: keyword,
    });
};

// 人群集市 - 主题专区 - 【根据不同专区名称区别曝光】
export const themeAreaShowLog = (page_type: string) => {
    dmpLogger.pageView('DMP_THEME_AREA', {
        account_id: accountInfo?.accountId,
        page_type,
    });
};

// 标签专区 - 点击【标签二级名称】
export const reportLabelLevel2NameLog = (label_level1_name: string, label_level2_name: string) => {
    dmpLogger.userClick('LABEL_LEVEL2_NAME', {
        account_id: accountInfo?.accountId,
        label_level1_name,
        label_level2_name,
    });
};

// 标签专区 - 点击【添加】
export const labelAddLog = (
    label_level1_name: string,
    label_level2_name: string,
    label_name: string,
) => {
    dmpLogger.userClick('DMP_LABEL_ADD', {
        account_id: accountInfo?.accountId,
        label_level1_name,
        label_level2_name,
        label_name,
    });
};

// 标签专区 - 点击【收藏】
export const labelCollectLog = (
    label_level1_name: string,
    label_level2_name: string,
    label_name: string,
) => {
    dmpLogger.userClick('DMP_LABEL_COLLECT', {
        account_id: accountInfo?.accountId,
        label_level1_name,
        label_level2_name,
        label_name,
    });
};

// 标签运算池 - 标签添加到运算池
export const reportAddLabelLog = (
    label_level1_name: string,
    label_level2_name: string,
    label_name: string,
) => {
    dmpLogger.userClick('DMP_LABEL_ADD', {
        account_id: accountInfo?.accountId,
        label_level1_name,
        label_level2_name,
        label_name,
    });
};

// 标签运算池 - 点击【生成人群】
export const reportGenerateGroupLog = () => {
    dmpLogger.userClick('DMP_GENERATE_GROUP', {
        account_id: accountInfo?.accountId,
    });
};

// 报表 - 曝光
export const reportShowLog = (source) => {
    dmpLogger.pageView('DMP_REPORT_SHOW', {
        account_id: accountInfo?.accountId,
        source,
    });
};

// 投放报表搜索
export const reportSearchLog = (keyword) => {
    if (!keyword) {
        return;
    }

    dmpLogger.userClick('DMP_REPORT_SEARCH', {
        account_id: accountInfo?.accountId,
        search_keyword: keyword,
    });
};

// 投放报表下载
export const reportDownloadLog = () => {
    dmpLogger.userClick('DMP_REPORT_DOWNLOAD', {
        account_id: accountInfo?.accountId,
    });
};

export const audienceLabelAddLog = ({ tags, subtags, op_type }) => {
    dmpLogger.userClick('LABEL_ADD', {
        account_id: accountInfo?.accountId,
        tags,
        subtags,
        op_type,
    });
};

// 数据洞察 - 受众分析 - 【根据tab区别曝光】
export const audienceShowLog = (tab: number) => {
    dmpLogger.pageView('DMP_AUDIENCE_REPORT', {
        account_id: accountInfo?.accountId,
        tab,
    });
};

// 数据洞察 - 受众分析 - 【切换tab】
export const audienceTabChangeLog = ({ tags, subtags }) => {
    dmpLogger.userClick('TAB_SWITCH', {
        account_id: accountInfo?.accountId,
        tags,
        subtags,
    });
};

//  数据洞察 - 受众分析 - 【快速添加标签】
export const audienceReportLog = () => {
    dmpLogger.userClick('LABEL_QUICK_ADD', {
        account_id: accountInfo?.accountId,
    });
};

export enum DownloadType {
    UserProp = 1, // 用户属性
    BehaviorIntension = 2, // 行为意向
    KuaishouCelebrity = 3, //快手网红
    ECommerceFavor = 4, // 电商偏好
}

//  数据洞察 - 受众分析 - 【下载表格】
export const downloadLog = (download_type) => {
    dmpLogger.userClick('DMP_DOWNLOAD', {
        account_id: accountInfo?.accountId,
        download_type,
    });
};

// 标签我的榜单曝光, 默认曝光第一个标签类别
export const labelListShowLog = (tab, tab_level2 = 1) => {
    const categoryMap = {
        click: 1,
        conversion: 2,
    };
    dmpLogger.pageView('MY_LABEL_LIST', {
        account_id: accountInfo?.accountId,
        tab: categoryMap[tab],
        tab_level2: tab_level2,
    });
};

export const labelListTabTypeClickLog = (tags, subtags = 1) => {
    const categoryMap = {
        click: 1,
        conversion: 2,
    };
    dmpLogger.userClick('TAB_SWITCH', {
        account_id: accountInfo?.accountId,
        tags: categoryMap[tags],
        subtags: subtags,
    });
};

// 标签行业榜单曝光
export const industryLabelListLog = (tab) => {
    dmpLogger.pageView('DMP_INDUSTRY_LABEL_LIST', {
        account_id: accountInfo?.accountId,
        tab: tab,
    });
};

export const tabSwitchLog = (tags) => {
    dmpLogger.userClick('TAB_SWITCH', {
        account_id: accountInfo?.accountId,
        tags: tags,
    });
};

export const labelListTabFilterLog = (tab = '点击效果榜单', op_type) => {
    dmpLogger.userClick('DMP_LABEL_LIST', {
        account_id: accountInfo?.accountId,
        tab,
        op_type,
    });
};

export const labelListFeedbackClickLog = () => {
    dmpLogger.userClick('DATA_INSIGHT_FEEDBACK', {
        account_id: accountInfo?.accountId,
    });
};

export const labelListFeedbackLSubmitLog = () => {
    dmpLogger.userClick('DATA_INSIGHT_FEEDBACK_SUBMIT', {
        account_id: accountInfo?.accountId,
    });
};

export const labelListAddTagLog = (tabs = 1, tags = 1) => {
    dmpLogger.userClick('LABEL_ADD', {
        account_id: accountInfo?.accountId,
        tab: tabs,
        tags,
    });
};

export const labelListBatchAddTagLog = (tabs = 1, tags = 1) => {
    dmpLogger.userClick('LABEL_BATCH', {
        account_id: accountInfo?.accountId,
        tab: tabs,
        tags,
    });
};
// 跳转投放管理平台
export const dspSkipLog = () => {
    dmpLogger.userClick('DMP_DSP_SKIP', {
        account_id: accountInfo?.accountId,
    });
};

// 跳转万象功能页
export const dmpOthersLog = (source, tab) => {
    dmpLogger.userClick('DMP_OTHERS', {
        account_id: accountInfo?.accountId,
        source: source,
        tab: tab,
    });
};

// 人群洞察对比
export const popInsightCompareLog = (data) => {
    dmpLogger.userClick('DMP_WANGXIANG_COMPARE', {
        account_id: accountInfo?.accountId,
        exp_pop_id: data?.rightId, // 对比人群包id
        base_pop_id: data?.leftId, // 选择人群包id
    });
};

// 点击学习专区埋点 由于是外链 相对于是页面曝光
export const learnLinkLog = ({ source, tab }) => {
    dmpLogger.pageView('DMP_OTHERS', {
        source,
        tab,
    });
};

/** 主题专区 **/
// // 行业人群页面曝光
// export const industryShowLog = () => {
//     dmpLogger.pageView('DMP_INDUSTRY_SHOW', {
//         account_id: accountInfo?.accountId,
//     });
// };
// 行业人群搜索人群包
export const industrySearchLog = (data) => {
    dmpLogger.userClick('DMP_INDUSTRY_SEARCH', {
        account_id: accountInfo?.accountId,
        search_keyword: data,
    });
};
// 行业人群操作
export const industryAddLog = (data, op_type) => {
    dmpLogger.userClick('DMP_INDUSTRY_ADD', {
        account_id: accountInfo?.accountId,
        op_type,
        first_industry: data?.firstIndustryId,
        second_industry: data?.secondIndustryId,
        pop_id: data?.audienceId,
    });
};
// 行业人群批量操作
export const industryBatchLog = (data, op_type) => {
    if (!Array.isArray(data)) return;
    dmpLogger.userClick('DMP_INDUSTRY_BATCH', {
        account_id: accountInfo?.accountId,
        op_type,
        pop_id: data.map((row) => row?.sourceId),
    });
};
// 行业人群排序
export const industryRankLog = (data) => {
    dmpLogger.userClick('DMP_INDUSTRY_RANK', {
        account_id: accountInfo?.accountId,
        op_type: ['', 'coverNum', 'heatScore', 'createTime'].findIndex(
            (field) => data.field === field,
        ),
        sequence: data?.order === 'ascend' ? 1 : 2,
    });
};
// 行业人群筛选
export const industrySelectLog = (op_type) => {
    dmpLogger.userClick('DMP_INDUSTRY_SELECT', {
        account_id: accountInfo?.accountId,
        op_type,
    });
};

// 三方精选-游戏行业标签组合曝光
export const sanfangGameShowLog = () => {
    dmpLogger.pageView('DMP_SANFANG_GAME_SHOW', {
        account_id: accountInfo?.accountId,
    });
};
// 三方精选-游戏行业标签组合生成人群
export const sanfangGameCreateLog = (pop_id) => {
    dmpLogger.userClick('DMP_SANFANG_GAME_CREATE', {
        account_id: accountInfo?.accountId,
        pop_id,
    });
};
// 三方精选-行业人群操作
export const sanfangAddLog = (data, op_type) => {
    dmpLogger.userClick('DMP_SANFANG_ADD', {
        account_id: accountInfo?.accountId,
        op_type,
        first_industry: data.firstIndustryId,
        second_industry: data.secondIndustryId,
        pop_id: data.id,
    });
};
//  三方精选搜索人群包
export const sanfangSearchLog = (search_keyword) => {
    dmpLogger.userClick('DMP_SANFANG_SEARCH', {
        account_id: accountInfo?.accountId,
        search_keyword,
    });
};
// 三方精选-行业人群排序
export const sanfangRankLog = (data) => {
    const sortList = ['', 'createTime', 'updateTime'];
    if (!sortList.includes(data.field)) {
        return;
    }
    dmpLogger.userClick('DMP_SANFANG_RANK', {
        account_id: accountInfo?.accountId,
        op_type: ['', 'createTime', 'updateTime'].findIndex((field) => data.field === field),
        sequence: data?.order === 'ascend' ? 1 : 2,
    });
};

// 三方精选-行业人群批量操作
export const sanfangBatchLog = (data) => {
    if (!Array.isArray(data)) return;
    dmpLogger.userClick('DMP_SANFANG_BATCH', {
        account_id: accountInfo?.accountId,
        ope_type: 1,
        pop_id: data.map((row) => row?.id),
        first_industry: data.map((row) => row.firstIndustryId),
        second_industry: data.map((row) => row.secondIndustryId),
    });
};
// 三方精选-行业人群筛选操作
export const sanfangSelectLog = (ope_type) => {
    dmpLogger.userClick('DMP_SANFANG_SELECT', {
        account_id: accountInfo?.accountId,
        ope_type: ['', 'firstIndustry', 'secondIndustry', 'dataSource'].findIndex(
            (i) => ope_type === i,
        ),
    });
};

/** 通用人群 **/
// // 通用人群页面曝光
// export const commonPopulationShowLog = () => {
//     dmpLogger.pageView('DMP_COMMON_SHOW', {
//         account_id: accountInfo?.accountId,
//     });
// };
// 通用人群搜索人群包
export const commonPopulationSearchLog = (search_keyword) => {
    dmpLogger.userClick('DMP_COMMON_SEARCH', {
        account_id: accountInfo?.accountId,
        search_keyword,
    });
};
// 通用人群操作
export const commonPopulationAddLog = (data, op_type) => {
    dmpLogger.userClick('DMP_COMMON_ADD', {
        account_id: accountInfo?.accountId,
        op_type,
        pop_id: data?.audienceId,
    });
};
// 通用人群排序
export const commonPopulationRankLog = (data) => {
    dmpLogger.userClick('DMP_COMMON_RANK', {
        account_id: accountInfo?.accountId,
        op_type: ['', 'coverNum', 'heatScore', 'createTime'].findIndex(
            (field) => data.field === field,
        ),
        sequence: data?.order === 'ascend' ? 1 : 2,
    });
};
// 通用人群批量操作
export const commonPopulationBatchLog = (data, op_type) => {
    if (!Array.isArray(data)) return;
    dmpLogger.userClick('DMP_COMMON_BATCH', {
        account_id: accountInfo?.accountId,
        op_type,
        pop_id: data.map((row) => row?.sourceId),
    });
};

/** 我的人群 **/
// 我的人群页面曝光
export const popShowLog = (appId: string) => {
    dmpLogger.pageView('DMP_POP_SHOW', {
        account_id: accountInfo?.accountId,
        app_id: appId,
    });
};

// 我的人群搜索人群包
export const popSearchLog = (query) => {
    dmpLogger.userClick('DMP_COMMON_SEARCH', {
        account_id: accountInfo?.accountId,
        search_keyword: query?.searchText,
        cover_num: query?.coverNum,
        population_status: query?.populationStatus,
    });
};

// 我的人群操作
export const popOperateLog = (type, pushType = 0) => {
    dmpLogger.userClick('DMP_POP_ADD', {
        account_id: accountInfo?.accountId,
        type: type,
        push_type: pushType,
    });
};

// 我的人群排序
export const popRankLog = (data) => {
    dmpLogger.userClick('DMP_POP_RANK', {
        account_id: accountInfo?.accountId,
        op_type: ['', 'status', 'createTime', 'coverNum', 'recordSize'].findIndex(
            (field) => data.field === field,
        ),
        sequence: data?.order === 'ascend' ? 1 : 2,
    });
};

// 我的人群批量操作
export const popOperateBatchLog = (opType) => {
    dmpLogger.userClick('DMP_POP_BATCH', {
        account_id: accountInfo?.accountId,
        op_type: opType,
    });
};

// 我的人群批量移动分组
export const popOperateBatchMoveLog = () => {
    dmpLogger.userClick('DMP_POP_OPERATE_BATCH_MOVE_GROUP', {
        account_id: accountInfo?.accountId,
    });
};

// 人群包重命名操作
export const popEditNameLog = (opType, popId) => {
    dmpLogger.userClick('DMP_POP_RENAME', {
        account_id: accountInfo?.accountId,
        op_type: opType,
        pop_id: popId,
    });
};

// 我的人群创建人群包
export const popCreateLog = (source, popId = 0) => {
    const embedPlatformName = getUrlParamByKey('embed');
    dmpLogger.userClick('DMP_POP_CREATE', {
        account_id: accountInfo?.accountId,
        source: source,
        pop_id: popId,
        embed: embedPlatformName,
    });
};

// 扩展人群包
export const popeExpandLog = (expandInfo: {
    orientation_name: string;
    is_reserve_seed: boolean;
    expand_client: number;
    expand_device: number;
    expand_gender: number;
    expand_age: string[];
    expand_number: number;
}) => {
    dmpLogger.userClick('DMP_MY_POP_LOOKLIKE', {
        account_id: accountInfo?.accountId,
        ...expandInfo,
    });
};

// 我的人群运算人群页面曝光
export const popComShowLog = () => {
    dmpLogger.pageView('DMP_POP_COMBINATION_SHOW', {
        account_id: accountInfo?.accountId,
    });
};

// 运算人群操作
export const popCombination = (opType) => {
    dmpLogger.userClick('DMP_POP_COMBINATION_OPERATION', {
        account_id: accountInfo?.accountId,
        op_type: opType,
    });
};

export enum GroupOperateType {
    Push = 1, // 推送
    Expand = 2, // 扩展
    Split = 3, // 拆分
    Insight = 4, // 洞察
    Detail = 5, // 详情
    Online = 6, // 上线
    BackOnline = 7, // 重新上线
    DeleteGroup = 8, // 删除
}

// 人群集市 - 我的人群 - 点击【人群功能列 & 操作列按钮】
export const popGroupOperateLog = (orientation_name: string, ope_type: number) => {
    dmpLogger.userClick('DMP_POP_OPERATE', {
        account_id: accountInfo?.accountId,
        orientation_name,
        ope_type,
    });
};

export enum MyPopulationOpeType {
    CreateGroup = 1, // 新建人群
    Search = 2, // 查询
    UploadGroup = 3, // 上传人群
    splitAndDedupe = 4, // 拆分与去重
}
// 人群集市 - 我的人群 - 点击【新建人群 | 上传人群 | 拆分与去重 | 查询】按钮
export const clickMyPopulationOpeLog = (ope_type: number) => {
    dmpLogger.userClick('DMP_POP_MY_OPERATE', {
        account_id: accountInfo?.accountId,
        ope_type,
    });
};

export enum PushType {
    Single = 1,
    Batch = 2,
}
// 人群集市 - 我的人群 - 点击【(推送 | 批量推送)的确认推送】按钮
export const clickMyPopulationPushLog = (pushInfo: {
    push_type: PushType;
    orientation_name: string[];
    is_success: boolean;
    fail_reason?: string;
}) => {
    dmpLogger.userClick('DMP_POP_PUSH', {
        account_id: accountInfo?.accountId,
        ...pushInfo,
    });
};

// 人群集市 - 主题专区 - 人群列表操作 - 添加到人群列表
export const addGroupLog = (orientation_name: string) => {
    dmpLogger.userClick('THEME_AREA_ADD_GROUP', {
        account_id: accountInfo?.accountId,
        orientation_name,
    });
};

// 人群集市 - 主题专区 - 人群列表操作 - 洞察
export const insightGroupLog = (orientation_name: string) => {
    dmpLogger.userClick('THEME_AREA_INSIGHT_GROUP', {
        account_id: accountInfo?.accountId,
        orientation_name,
    });
};

// 人群集市 - 数据源 - 点击【新建数据源】
export const popCreateDataSource = () => {
    dmpLogger.userClick('CREATE_DATA_SOURCE', {
        account_id: accountInfo?.accountId,
    });
};

// 人群集市 - 数据源 - 点击【新建人群包】
export const popCreateGroup = () => {
    dmpLogger.userClick('CREATE_GROUP', {
        account_id: accountInfo?.accountId,
    });
};

export enum dataSourceAddType {
    Detail = 1, // 详情
    Crowd = 2, // 生成人群
    Update = 3, //更新数据文件
}

// 人群集市 - 数据源 - 操作
export const dataSourceAddLog = (orientation_name: string, ope_type: number) => {
    dmpLogger.userClick('DMP_DATA_SOURCE_ADD', {
        account_id: accountInfo?.accountId,
        orientation_name,
        ope_type,
    });
};

// 点击 - 用户手册
export const userManualLog = (user_manual_name) => {
    dmpLogger.userClick('USER_MANUAL', {
        account_id: accountInfo?.accountId,
        user_manual_name,
    });
};

// 点击 - 新手引导
export const introductionVideoLog = (user_manual_name) => {
    dmpLogger.userClick('INTRODUCTION_VIDEO', {
        account_id: accountInfo?.accountId,
        user_manual_name,
    });
};

// 点击 - 新手引导 - 受众分析
export const introductionVideoLog2 = (introduction_video_name) => {
    dmpLogger.userClick('INTRODUCTION_VIDEO', {
        account_id: accountInfo?.accountId,
        introduction_video_name,
    });
};

// 我的人群新建人群页面曝光
export const popCreateShowLog = () => {
    dmpLogger.pageView('DMP_POP_CREATE_SHOW', {
        account_id: accountInfo?.accountId,
    });
};

/** 词包管理 **/
// 词包管理页面曝光
export const toolboxWordShowLog = () => {
    dmpLogger.pageView('DMP_TOOLBOX_WORD', {
        account_id: accountInfo?.accountId,
    });
};
// 词包管理搜索人群包
export const toolboxWordSearchLog = (search_keyword: string) => {
    dmpLogger.userClick('DMP_TOOLBOX_WORD_SEARCH', {
        account_id: accountInfo?.accountId,
        search_keyword,
    });
};

export enum WordOperateType {
    View = 1, // 查看
    Edit = 2, // 编辑
    Duplicate = 3, // 复制
    Delete = 4, // 删除
    Crowd = 5, // 生成人群
}

// 词包创建操作
export const toolboxCreateAddLog = (source: number) => {
    dmpLogger.userClick('DMP_TOOLBOX_WORD_CREATE', {
        account_id: accountInfo?.accountId,
        source,
    });
};
// 词包管理筛选
export const toolboxWordSelectLog = (ope_type) => {
    dmpLogger.userClick('DMP_TOOLBOX_WORD_SELECT', {
        account_id: accountInfo?.accountId,
        ope_type,
    });
};

// 词包操作
export const toolboxWordAddLog = (ope_type) => {
    dmpLogger.userClick('DMP_TOOLBOX_WORD_ADD', {
        account_id: accountInfo?.accountId,
        ope_type,
    });
};

// 词包管理导入与生成
export const labelWordAddLog = (ope_type, source) => {
    dmpLogger.userClick('DMP_LABEL_WORD_ADD', {
        account_id: accountInfo?.accountId,
        ope_type,
        source,
    });
};

export enum StoreSourceType {
    Create = 1, // 创建门店包
    StartMatch = 2, // 开始匹配
}

// 门店管理开始匹配
export const startMatchLog = (source) => {
    dmpLogger.userClick('DMP_TOOLBOX_STORE_CREATE', {
        account_id: accountInfo?.accountId,
        source,
    });
};

export enum StoreOperateType {
    View = 1, // 查看
    Edit = 2, // 编辑
    Duplicate = 3, // 复制
    Delete = 4, // 删除
    Crowd = 5, // 生成人群
}

// 门店操作
export const toolboxStoreCreate = (ope_type) => {
    dmpLogger.userClick('DMP_TOOLBOX_STORE_ADD', {
        account_id: accountInfo?.accountId,
        ope_type,
    });
};

// 关键词推荐搜索关键词
export const keywordSearchLog = (search_keyword) => {
    dmpLogger.userClick('DMP_KEYWORD_SEARCH', {
        account_id: accountInfo?.accountId,
        search_keyword,
    });
};

// 关键词操作
export const keywordAddLog = (ope_type) => {
    dmpLogger.userClick('DMP_TOOLBOX_KEYWORD_ADD', {
        account_id: accountInfo?.accountId,
        ope_type,
    });
};

// 创建词包
export const keywordCreateLog = () => {
    dmpLogger.userClick('DMP_TOOLBOX_KEYWORD_CREATE', {
        account_id: accountInfo?.accountId,
    });
};

// 创建人群包
export const keywordCreateGroupLog = () => {
    dmpLogger.userClick('DMP_TOOLBOX_KEYWORD_CREATE_GROUP', {
        account_id: accountInfo?.accountId,
    });
};

// 人群同步
export const groupListPushLog = () => {
    dmpLogger.userClick('GROUP_LIST_PUSH', {
        account_id: accountInfo?.accountId,
    });
};

// 加密工具-开始加密
export const startEncryptionLog = (encryption_type, match_type) => {
    dmpLogger.userClick('START_ENCRYPTION', {
        account_id: accountInfo?.accountId,
        encryption_type,
        match_type,
    });
};

// 消息强弹点击忽略
export const messageInfoCloseLog = () => {
    dmpLogger.userClick('DMP_INFO_CLOSE_CLICK');
};

// 视频引导
// 培训视频查看
export const videoShowClickLog = (tab) => {
    const params = {
        account_id: accountInfo?.accountId,
        tab: undefined,
    };

    if (tab) {
        params.tab = tab;
    }
    dmpLogger.userClick('INTRODUCTION_VIDEO', params);
};
export const videoShowLog = (tab) => {
    const params = {
        account_id: accountInfo?.accountId,
        tab: undefined,
    };

    if (tab) {
        params.tab = tab;
    }
    dmpLogger.userClick('INTRODUCTION_VIDEO_SHOW', params);
};
// 培训视频播放
export const videoPlayLog = (data) => {
    const params = {
        account_id: accountInfo?.accountId,
        duration: data?.duration,
        played_duration: data?.time,
        tab: undefined,
    };

    if (data.tab) {
        params.tab = data.tab;
    }

    dmpLogger.userClick('INTRODUCTION_VIDEO_PLAY', params);
};

export const videoPlayedLog = (data) => {
    const params = {
        account_id: accountInfo?.accountId,
        tab: undefined,
        duration: data?.duration,
        played_duration: data?.time,
    };

    if (data.tab) {
        params.tab = data.tab;
    }

    dmpLogger.userClick('INTRODUCTION_VIDEO_RETURN', params);
};
//人群包画像-基础特征-自定义画像标签
export const portraitCustomizeDimChangeLog = (type) => {
    dmpLogger.userClick('CUSTOMIZE_PORTRAIT', {
        account_id: accountInfo?.accountId,
        type: type,
    });
};
// 人群画像-单画像人群筛选
export const portraitPopulationSelectLog = () => {
    dmpLogger.userClick('PORTRAIT_SELECT', {
        account_id: accountInfo?.accountId,
    });
};
// 人群画像-tab 切换
export const portraitTabChangeLog = (tab) => {
    dmpLogger.userClick('PORTRAIT_TAB', {
        account_id: accountInfo?.accountId,
        tab,
    });
};
// 人群画像-画像对比按钮
export const portraitCompareLog = () => {
    dmpLogger.userClick('PORTRAIT_COMPARE', {
        account_id: accountInfo?.accountId,
    });
};

// 人群优化-智能优选 新建人群按钮点击
export const intelligenceSelectionAddPopLog = () => {
    dmpLogger.userClick('DMP_INTELLIGENCE_SELECTION_POP_ADD', {
        account_id: accountInfo?.accountId,
    });
};

//  人群拆分--点击列表拆分按钮
export const tableSplitLog = () => {
    dmpLogger.userClick('POPULATION_SPLIT', {
        account_id: accountInfo?.accountId,
    });
};
//  人群拆分--点击【拆分与去重】按钮
export const splitAndDedupeLog = () => {
    dmpLogger.userClick('POPULATION_SPLIT_AND_REDUCE', {
        account_id: accountInfo?.accountId,
    });
};

//  【拆分与去重页面曝光】
export const splitPageShowLog = () => {
    dmpLogger.pageView('SPLIT_DEDUPLICATE', {
        account_id: accountInfo?.accountId,
    });
};

//  人群去重--点击【预估】按钮
export const estimateLog = (session, pop_num) => {
    const params = {
        account_id: accountInfo?.accountId,
        pop_num: pop_num,
        session: session,
    };
    dmpLogger.userClick('REDUCE_ESTIMATE', params);
};

//  人群去重--点击【重新预估】按钮
export const reEstimateLog = (session, pop_num) => {
    const params = {
        account_id: accountInfo?.accountId,
        pop_num: pop_num,
        session: session,
    };
    dmpLogger.userClick('REDUCE_ESTIMATE_AGAIN', params);
};

//  【推荐专区TAB页面曝光】
export const recommendPageShowLog = () => {
    dmpLogger.pageView('RECOMMEND_PAGE', {
        account_id: accountInfo?.accountId,
    });
};

// 推荐专区 - 点击添加按钮（标签推荐）
export const addRecommendTagLog = (recommendId: number, tagName: string) => {
    const params = {
        account_id: accountInfo?.accountId,
        rec_id: recommendId,
        tag_name: tagName,
    };
    dmpLogger.userClick('ADD_TAG_BUTTON', params);
};

// 推荐专区 - 点击添加按钮（专属人群推荐）
export const addRecommendExclusiveCrowdLog = (orientationId: number, orientationName: string) => {
    const params = {
        account_id: accountInfo?.accountId,
        orientation_id: orientationId,
        orientation_name: orientationName,
    };
    dmpLogger.userClick('ADD_PACK_OWN', params);
};

// 推荐专区 - 点击添加按钮（行业人群推荐）
export const addRecommendIndustryCrowdLog = (orientationId: number, orientationName: string) => {
    const params = {
        account_id: accountInfo?.accountId,
        orientation_id: orientationId,
        orientation_name: orientationName,
    };
    dmpLogger.userClick('ADD_PACK_IND', params);
};

// 推荐专区 - 点击添加按钮（行业人群推荐）
export const viewRecommendCrowdDetailLog = (orientationId: number, orientationName: string) => {
    const params = {
        account_id: accountInfo?.accountId,
        orientation_id: orientationId,
        orientation_name: orientationName,
    };
    dmpLogger.userClick('VIEW_DETAIL', params);
};

// 人群诊断 - 点击查看报告按钮
export const viewClueReportLog = () => {
    const params = {
        account_id: accountInfo?.accountId,
    };
    dmpLogger.userClick('CLUE_CHECK_BUTTON', params);
};

// 人群诊断 - 点击生成人群按钮
export const viewClueAddPopulationLog = () => {
    const params = {
        account_id: accountInfo?.accountId,
    };
    dmpLogger.userClick('CLUE_POP_ADD', params);
};

// 人群诊断 - 点击生成人群按钮
export const viewClueAnalyzeLog = () => {
    const params = {
        account_id: accountInfo?.accountId,
    };
    dmpLogger.userClick('CLUE_POP_ANALYSE', params);
};

// 人群诊断 - 点击新建报告按钮
export const viewClueCreateReportLog = () => {
    const params = {
        account_id: accountInfo?.accountId,
    };
    dmpLogger.userClick('CLUE_INQUIRE_BUTTON', params);
};

// 投广分析 - 点击新建报告按钮
export const viewAdAnalysisCreateLog = () => {
    const params = {
        account_id: accountInfo?.accountId,
    };
    dmpLogger.userClick('NEW_REPORT', params);
};

// 投广分析 - 点击查看报告按钮
export const viewAdAnalysisReportLog = (report_name: string, report_id: number) => {
    const params = {
        account_id: accountInfo?.accountId,
        report_name,
        report_id,
    };
    dmpLogger.userClick('CHECK_REPORT_RESULR', params);
};

// 投广分析 - 点击详情按钮
export const viewAdAnalysisDetailLog = (report_name: string, report_id: number) => {
    const params = {
        account_id: accountInfo?.accountId,
        report_name,
        report_id,
    };
    dmpLogger.userClick('CHECK_REPORT', params);
};

// 投广分析 - 点击编辑按钮
export const viewAdAnalysisEditLog = (report_name: string, report_id: number) => {
    const params = {
        account_id: accountInfo?.accountId,
        report_name,
        report_id,
    };
    dmpLogger.userClick('EDIT_REPORT', params);
};

// 投广分析 - 点击删除按钮
export const viewAdAnalysisDeleteLog = (report_name: string, report_id: number) => {
    const params = {
        account_id: accountInfo?.accountId,
        report_name,
        report_id,
    };
    dmpLogger.userClick('DELETE_REPORT', params);
};

// 投广分析 - 打开创建抽屉 - 点击创建按钮
export const viewAdAnalysisCreateReportLog = (
    report_name: string,
    report_id: number,
    is_success: boolean,
    fail_reason?: any,
) => {
    const params = {
        account_id: accountInfo?.accountId,
        report_name,
        report_id,
        is_success,
        fail_reason,
    };
    dmpLogger.userClick('CREAT_REPORT', params);
};

// 投广分析 - 点击人群洞察按钮
export const viewAdAnalysisInsightLog = (
    report_name: string,
    report_id: number,
    group_id: number,
    group_name: string,
) => {
    const params = {
        account_id: accountInfo?.accountId,
        report_name,
        report_id,
        group_id,
        group_name,
    };
    dmpLogger.userClick('TG_POP_ANALYSE', params);
};

// 投广分析 - 点击生成人群按钮
export const viewAdAnalysisAddGroupLog = (
    report_name: string,
    report_id: number,
    group_id: number,
    group_name: string,
    is_success: boolean,
    fail_reason?: any,
) => {
    const params = {
        account_id: accountInfo?.accountId,
        report_name,
        report_id,
        group_id,
        group_name,
        is_success,
        fail_reason,
    };
    dmpLogger.userClick('DG_POP_ADD', params);
};

// 首页 - 点击功能引导
export const viewHomeGuideLog = (button_name: string) => {
    const params = {
        account_id: accountInfo?.accountId,
        second_industry_name: localStorage.getItem('secondIndustryName'),
        button_name,
    };
    dmpLogger.userClick('FUNCTION_CLICK', params);
};

// 首页 - 点击添加推荐标签
export const viewAddRecommendLabelLog = (label_name: string) => {
    const params = {
        account_id: accountInfo?.accountId,
        second_industry_name: localStorage.getItem('secondIndustryName'),
        label_name,
    };
    dmpLogger.userClick('DMP_LABEL_ADD', params);
};

// 首页 - 点击平台动态
export const viewHomePlatformDynamic = (message_name: string) => {
    const params = {
        account_id: accountInfo?.accountId,
        second_industry_name: localStorage.getItem('secondIndustryName'),
        message_name,
    };
    dmpLogger.userClick('DMP_MESSAGE_CLICK', params);
};

// 首页 - 点击添加推荐人群
export const viewAddRecommendGroupLog = (group_name: string) => {
    const params = {
        account_id: accountInfo?.accountId,
        second_industry_name: localStorage.getItem('secondIndustryName'),
        group_name,
    };
    dmpLogger.userClick('DMP_GROUP_ADD', params);
};

// 首页 - 点击查看课程
export const viewRecommendCourseLog = (clx_name: string) => {
    const params = {
        account_id: accountInfo?.accountId,
        second_industry_name: localStorage.getItem('secondIndustryName'),
        clx_name,
    };
    dmpLogger.userClick('DMP_CLX_ADD', params);
};
